<template>
  <Dialog
    width="560px"
    height="unset"
    titleAlign="left"
    :title="null"
    :subTitle="null"
    :visible="visible"
    hideCloseBtn
    @close="closeDialog"
    mobileRenderType="drawerDialog"
    customClass="vip-release-dialog"
  >
    <div
      class="release-form-wrapper"
      @scroll="handleScroll"
      @touchstart="handleScroll"
      @touchmove="handleScroll"
      @touchend="handleScroll"
    >
      <div class="mobile-nav" :class="`${bannerOpacity ? 'fixed' : ''}`">
        <div class="left">
          <img
            v-if="!bannerOpacity"
            @click="closeDialog"
            class="back"
            src="@/assets/img/release/mobile-back.png"
          />
          <img
            v-else
            @click="closeDialog"
            class="back"
            src="@/assets/img/release/mobile-back-black.png"
          />
          <span class="sub-title" v-if="bannerOpacity">{{
            $$t("create.release")
          }}</span>
        </div>
        <!-- <img
          @click="$router.push('/release')"
          class="question"
          src="@/assets/img/release/question.png"
        /> -->
        <span @click="$router.push('/release')" class="desc-more">{{
          $$t("create.learn_more")
        }}</span>
      </div>
      <div class="group">
        <div class="title">
          {{ $$t("create.global_release") }}
          <!-- <img
            @click="$router.push('/release')"
            src="@/assets/img/release/question.png"
          /> -->
        </div>
        <div class="desc">
          <span class="desc-text">
            {{
              feedListStore.release.item?.credit_type === 2
                ? "Release on 200+ platforms worldwide, while also gaining ownership of the song!"
                : "Release on 200+ platforms worldwide!"
            }}
          </span>
          <span @click="$router.push('/release')" class="desc-more">{{
            $$t("create.learn_more")
          }}</span>
        </div>
        <div @click="closeDialog" class="close-icon">
          <img src="@/assets/img/release/modal_close.png" />
        </div>
      </div>

      <div class="form">
        <div class="scrollable-content">
          <div class="form-title">{{ $$t("create.release_dedail_title") }}</div>
          <div class="form-desc">
            {{
              $$t("create.release_remain_count").replace(
                "[remain_count]",
                userDataStore.creditInfo.release_amount_left || 0
              )
            }}
          </div>
          <div class="release-status" v-if="ruleForm.releaseState === 1">
            <div class="bubble">
              <img src="@/assets/img/release/review-icon.png" />
              <span>{{ $$t("create.under_review") }}</span>
            </div>
          </div>
          <div class="release-status" v-if="ruleForm.releaseState === 2">
            <div class="bubble">
              <img src="@/assets/img/release/not-approved.png" />
              <span>{{ $$t("create.review_not_approved") }}</span>
            </div>
          </div>
          <el-form
            ref="ruleFormRef"
            style="width: 100%"
            :model="ruleForm"
            status-icon
            :rules="rules"
            label-width="auto"
            class="release-ruleForm"
          >
            <div class="form-item-wrapper">
              <div class="form-item-label">
                {{ $$t("create.cover") }}*<HoverTip
                  :content="$$t('create.cover_tip')"
                  ><img src="@/assets/img/release/question_white.png" />
                </HoverTip>
              </div>
              <el-form-item prop="cover">
                <div class="upload-card">
                  <el-upload
                    ref="upload"
                    class="avatar-uploader"
                    action=""
                    :limit="1"
                    :disabled="disableEdit"
                    :on-exceed="handleExceed"
                    :show-file-list="false"
                    :auto-upload="false"
                    :on-success="handleAvatarSuccess"
                    :on-change="beforeAvatarUpload"
                  >
                    <img
                      @click.stop="() => handleAvatarRemove()"
                      v-if="ruleForm.cover && !disableEdit"
                      src="@/assets/img/release/avatar_close.png"
                      class="avatar-close"
                    />
                    <img
                      v-if="ruleForm.cover"
                      :src="ruleForm.cover"
                      class="avatar"
                    />
                    <div v-else class="avatar-uploader-icon">
                      <img src="@/assets/img/release/upload_plus.png" />
                    </div>
                  </el-upload>
                </div>
              </el-form-item>
            </div>
            <div class="form-item-wrapper">
              <div class="form-item-label">
                {{ $$t("create.release_description") }}*
              </div>
              <el-form-item prop="desc">
                <!-- type="textarea" -->
                <div
                  class="customer-textarea"
                  :class="`${disableEdit && 'disabled'}`"
                >
                  <textarea
                    class="desc-textarea"
                    :disabled="disableEdit"
                    resize="none"
                    :value="ruleForm.desc"
                    maxlength="3000"
                    @input="handleDescInput"
                    @blur="handleDescCheck"
                    @compositionstart="handleCompositionStart"
                    @compositionend="handleCompositionEnd"
                  ></textarea>
                  <div class="desc-size">{{ descSize }}/3000</div>
                </div>
                <!-- <el-input
                  :rows="5"
                  v-model="ruleForm.desc"
                  autocomplete="off"
                  resize="none"
                  maxlength="3000"
                  :disabled="disableEdit"
                ></el-input> -->
              </el-form-item>
            </div>
            <div class="form-item-wrapper">
              <div class="form-item-label">{{ $$t("create.song_title") }}*</div>
              <el-form-item prop="songTitle">
                <el-input
                  :disabled="disableEdit"
                  v-model="ruleForm.songTitle"
                  autocomplete="off"
                />
              </el-form-item>
            </div>
            <div class="form-item-wrapper">
              <div class="form-item-label">
                {{ $$t("create.artist_name") }}*
              </div>
              <el-form-item prop="artistName">
                <el-input
                  :disabled="disableEdit"
                  v-model="ruleForm.artistName"
                  autocomplete="off"
                />
              </el-form-item>
            </div>
            <div class="form-item-wrapper">
              <div class="form-item-label">{{ $$t("create.lyricist") }}*</div>
              <el-form-item prop="lyricist">
                <el-input
                  :disabled="disableEdit"
                  v-model="ruleForm.lyricist"
                  placeholder="Real Name"
                  autocomplete="off"
                />
              </el-form-item>
            </div>
            <div class="form-item-wrapper">
              <div class="form-item-label">{{ $$t("create.composer") }}*</div>
              <el-form-item prop="composer">
                <el-input
                  :disabled="disableEdit"
                  v-model="ruleForm.composer"
                  autocomplete="off"
                />
              </el-form-item>
            </div>
            <div class="form-item-wrapper">
              <div class="form-item-label">
                {{ $$t("create.personal_profile_links")
                }}<HoverTip
                  content="If you already have an artist homepage, please provide the link so we can bind the works you release on our platform to your homepage, ensuring consistency in your music releases."
                  ><img src="@/assets/img/release/question_white.png" />
                </HoverTip>
              </div>
              <el-form-item prop="personalLinks">
                <div
                  v-for="(item, index) in ruleForm.personalLinks"
                  class="link-line"
                >
                  <el-input
                    v-model="item.link"
                    :placeholder="$$t('create.please_input')"
                    class="input-with-select"
                    :disabled="disableEdit"
                  >
                    <template #prepend>
                      <el-select
                        :disabled="disableEdit"
                        v-model="item.platform"
                        :placeholder="$$t('create.select')"
                        style="width: 115px"
                        :suffix-icon="selectIconComponent"
                      >
                        <el-option
                          v-for="item in supportPlatforms"
                          :label="item.platform"
                          :value="item.idx"
                        />
                      </el-select>
                    </template>
                  </el-input>
                  <el-icon
                    @click="handleAddLink"
                    class="add-link"
                    v-if="
                      index === ruleForm.personalLinks.length - 1 &&
                      !disableEdit &&
                      ruleForm.personalLinks.length < 20
                    "
                    ><Plus
                  /></el-icon>
                  <el-icon
                    @click="() => handleRemoveLink(index)"
                    class="add-link"
                    v-else-if="!disableEdit"
                    ><Minus
                  /></el-icon>
                </div>
              </el-form-item>
              <el-form-item v-if="!disableEdit">
                <Button
                  :renderStyle="{
                    '--padding': '0 12px',
                    '--width': '232px',
                    '--height': '48px',
                    '--borderRadius': '62px',
                    '--fontColor': '#000000',
                    '--fontSize': '16px',
                    '--fontWeight': 'bold',
                    '--border': 'none',
                    '--background': '#94ADFF',
                    '--backgroundHover': '#94ADFF90',
                    '--fontColorHover': '#fff',
                    marginRight: '12px',
                  }"
                  @click="() => submitForm(1)"
                >
                  {{
                    ruleForm.releaseState === 2
                      ? $$t("create.cancel")
                      : $$t("mine.Save")
                  }}
                </Button>
                <Button
                  :renderStyle="{
                    '--padding': '0 12px',
                    '--width': '232px',
                    '--height': '48px',
                    '--borderRadius': '50px',
                    '--fontColor': '#000000',
                    '--fontSize': '16px',
                    '--fontWeight': 'bold',
                    '--border': 'none',
                    '--background':
                      'linear-gradient(102deg, #4FDEFF 0%, #E675FF 100%)',
                    '--backgroundHover':
                      'linear-gradient(102deg, #4FDEFF90 0%, #E675FF90 100%)',
                    '--fontColorHover': '#fff',
                  }"
                  @click="() => submitForm(2)"
                >
                  {{
                    ruleForm.releaseState === 2
                      ? $$t("create.rerelease")
                      : $$t("create.submit")
                  }}
                </Button>
              </el-form-item>
              <el-form-item v-else>
                <Button
                  :renderStyle="{
                    '--padding': '0 12px',
                    '--width': '232px',
                    '--height': '42px',
                    '--borderRadius': '50px',
                    '--fontColor': '#000000',
                    '--fontSize': '16px',
                    '--fontWeight': 'bold',
                    '--border': 'none',
                    '--background':
                      'linear-gradient(102deg, #4FDEFF 0%, #E675FF 100%)',
                    '--backgroundHover': 'rgba(255, 255, 255, 0.2)',
                    '--fontColorHover': '#fff',
                    margin: '0 auto',
                  }"
                  @click="() => submitForm(3)"
                >
                  {{ $$t("create.withdraw_release") }}
                </Button>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <TipModal
      v-if="tipModalData.visible"
      :content="tipModalData.content"
      :confirmText="tipModalData.confirmText"
      :cancelText="tipModalData.cancelText"
      :onConfirm="tipModalData.onConfirm"
      :onCancel="tipModalData.onCancel"
    />
  </Dialog>
</template>
<script setup lang="jsx">
import { Plus, Minus } from "@element-plus/icons-vue"
import { genFileId } from "element-plus"
import useFeedListStore from "@/store/create/feedListDataStore.js"
import selectIcon from "@/assets/img/release/circle_down.png"
import Button from "@/components/basic/button/Button.vue"
import TipModal from "./components/tipModal.vue"
import { computed, onUnmounted, onMounted, ref, watchEffect } from "vue"
import { miscConfig } from "@/api/api/apiCommon.js"
import objectStorage, {
  getObjectStorageFullUrl,
} from "@/lib/objectStorage/objectStorage.js"
import HoverTip from "./components/hoverTip.vue"
import useUserDataStore from "@/store/userDataStore"
import message from "@/components/functionCallComponent/message/message.js"

const feedListStore = useFeedListStore()
const userDataStore = useUserDataStore()
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const globalProperties = (
  getCurrentInstance() || window?.$getVueCurrentInstance?.()
).appContext?.config?.globalProperties

const selectIconComponent = () => (
  <img style={{ width: "16px", height: "16px" }} src={selectIcon} />
)

const releaseInfo = computed(() => feedListStore.release.release_info)

const scrollTop = ref(0)
const bannerOpacity = computed(() => {
  return scrollTop.value >= 188
})

const ruleForm = reactive({
  // 0-未提交发行 1-已提交，审核中 2-已提交，审核拒绝 3-发行中 4-发行成功
  releaseState: 0,
  coverRaw: null, // 上传的原始文件
  cover: "", // 封面
  pathKey: "", // 上传到对象存储的key
  desc: "",
  songTitle: "",
  artistName: "",
  lyricist: "",
  composer: "",
  personalLinks: [
    {
      platform: 1,
      link: "",
    },
  ],
})

const disableEdit = computed(() => {
  return ruleForm.releaseState === 1
})

const handleScroll = (event) => {
  // 你可以在这里处理滚动高度
  scrollTop.value = event.target.scrollTop
  console.log("Scroll Top:", scrollTop.value)
}

watchEffect(() => {
  if (releaseInfo.value) {
    if (releaseinfo.value?.cover) {
      ruleForm.cover = getObjectStorageFullUrl(releaseinfo.value?.cover)
      ruleForm.pathKey = releaseinfo.value?.cover
    }
    if (releaseinfo.value?.release_state) {
      ruleForm.releaseState = releaseinfo.value?.release_state
    }
    // 一定会有的
    ruleForm.composer = releaseinfo.value?.composer
    ruleForm.artistName = releaseinfo.value?.artist_name
    ruleForm.songTitle = releaseinfo.value?.title
    ruleForm.lyricist = releaseinfo.value?.lyricist
    // 不是一定有的
    ruleForm.desc = releaseinfo.value?.description
    ruleForm.personalLinks = releaseinfo.value?.platform_links || [
      {
        platform: 1,
        link: "",
      },
    ]
  }
})

const closeDialog = () => {
  feedListStore.closeReleaseFormDialog()
}

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
})

const reg = new RegExp(
  "^((https|http)?://)" + "?[0-9a-zA-Z]+[0-9a-zA-Z_-]*(\\.[a-zA-Z]+)+"
)
const upload = ref(null)

const ruleFormRef = ref(null)

const tipModalData = reactive({
  visible: false,
  title: $$t("create.release_rules"),
  confirmText: "",
  cancelText: $$t("create.i_knew"),
  content: "",
  onConfirm: () => {},
  onCancel: () => {},
})

// 支持的平台，后端下发数据
const supportPlatforms = ref([])

const descSize = computed(() => {
  return ruleForm.desc?.length || 0
})

const rules = reactive({
  cover: [
    { required: true, message: $$t("create.cannot_be_null"), trigger: "blur" },
  ],
  desc: [
    { required: true, message: $$t("create.cannot_be_null"), trigger: "blur" },
  ],
  songTitle: [
    { required: true, message: $$t("create.cannot_be_null"), trigger: "blur" },
  ],
  artistName: [
    { required: true, message: $$t("create.cannot_be_null"), trigger: "blur" },
  ],
  lyricist: [
    { required: true, message: $$t("create.cannot_be_null"), trigger: "blur" },
  ],
  composer: [
    { required: true, message: $$t("create.cannot_be_null"), trigger: "blur" },
  ],
  personalLinks: [
    {
      validator: (rule, value, callback) => {
        console.log(value.length, value)
        if (
          value.length &&
          value.some((item) => item.link.length && !reg.test(item.link))
        ) {
          callback(new Error("Invalid link"))
        } else {
          callback()
        }
      },
      trigger: "blur",
    },
  ],
})

const submitForm = (submitAction) => {
  if (submitAction === 1 && ruleForm.releaseState !== 2) {
    globalProperties?.logClickEvent("release_save", {
      entity: "save",
    })
  } else if (submitAction === 3) {
    globalProperties?.logClickEvent("release_withdraw", {
      entity: "withdraw",
    })
  }

  // 审核失败的时候，保存实际上是取消的逻辑
  if (submitAction === 1 && ruleForm.releaseState === 2) {
    feedListStore.closeReleaseFormDialog()
  }
  const form = ruleFormRef.value
  form.validate((valid) => {
    if (valid) {
      console.log(ruleForm)

      // 过滤掉空的链接，或者不满足格式的链接
      const formCopy = JSON.parse(JSON.stringify(ruleForm))

      formCopy.personalLinks = formCopy.personalLinks.filter(
        (item) => item.link && item.platform && reg.test(item.link)
      )

      if (formCopy.personalLinks.length === 0) {
        delete formCopy.personalLinks
      }
      feedListStore
        .doRelease({ ...formCopy, coverRaw: ruleForm.coverRaw, submitAction })
        .then((res) => {
          console.log
          if (res.code === 200) {
            message.success({
              position: "top",
              content:
                submitAction === 1
                  ? $$t("create.save_success")
                  : submitAction === 2
                  ? $$t("create.submit_success")
                  : $$t("create.withdraw_success"),
            })
            if (submitAction === 1) return // 保存不关闭
            feedListStore.closeReleaseFormDialog()
            if (submitAction === 2 || submitAction === 3) {
              feedListStore.setTargetSongReleaseData(
                feedListStore.release.pitem,
                feedListStore.release.item,
                {
                  release_state: submitAction === 2 ? 1 : 0, // 1-已提交，审核中
                }
              )
            }
            // 提交成功打点
            if (submitAction === 2) {
              globalProperties?.logClickEvent("release_submit", {
                entity: "submit",
                releaseSubmitStare: "true",
              })
            }
          } else {
            // 提交失败打点
            if (submitAction === 2) {
              globalProperties?.logClickEvent("release_submit", {
                entity: "submit",
                releaseSubmitStare: "false",
              })
            }
            message.error({
              position: "top",
              content:
                submitAction === 1
                  ? $$t("create.save_failed")
                  : submitAction === 2
                  ? $$t("create.submit_failed")
                  : $$t("create.withdraw_failed"),
            })
          }
        })
    } else {
      message.error({
        position: "top",
        content: $$t("create.submit_failed"),
      })
      return false
    }
  })
}
const handleCompositionStart = () => {
  renderData.inputing = true
}

const handleCompositionEnd = (e) => {
  renderData.inputing = false
  handleDescInput(e)
}
const handleDescInput = (e) => {
  if (!renderData.inputing) {
    ruleForm.desc = e.target.value
  }
}

const handleDescCheck = () => {
  const form = ruleFormRef.value
  form.validateField("desc", (res) => {
    console.log(res)
  })
}

const handleAvatarSuccess = (response, uploadFile) => {
  ruleForm.cover = URL.createObjectURL(uploadFile.raw)
}

const handleAddLink = () => {
  if (ruleForm.personalLinks.length === 20) return
  ruleForm.personalLinks.push({
    platform: supportPlatforms.value?.[0]?.idx,
    link: "",
  })
}

const handleExceed = (files) => {
  upload.value?.clearFiles()
  const file = files[0]
  file.uid = genFileId()
  upload.value?.handleStart(file)
}

const handleRemoveLink = (index) => {
  ruleForm.personalLinks.splice(index, 1)
}

const handleAvatarRemove = () => {
  upload.value?.clearFiles()
  ruleForm.cover = ""
}

const checkFile = (file) => {
  const maxSize = 10 * 1024 * 1024 // 10MB
  const allowedSizes = [{ width: 1440, height: 1440 }]

  return new Promise((resolve, reject) => {
    if (file.size > maxSize) {
      reject("File size must be no larger than 10MB.")
      return
    }

    const img = new Image()
    img.onload = () => {
      const isValidSize = allowedSizes.some(
        (size) =>
          img.width >= size.width &&
          img.height >= size.height &&
          img.width === img.height
      )

      if (!isValidSize) {
        reject("Image size must be 3000x3000 or 1440x1440.")
      } else {
        resolve("File is valid")
      }
    }

    img.onerror = () => {
      reject("Invalid image file.")
    }

    img.src = URL.createObjectURL(file)
  })
}

const beforeAvatarUpload = async (rawFile) => {
  try {
    const res = await checkFile(rawFile.raw)
    ruleForm.coverRaw = rawFile
    ruleForm.changed = true
    ruleForm.cover = URL.createObjectURL(rawFile.raw)
  } catch (error) {
    message.error({
      position: "top",
      content: $$t("create.image_format_incorrect"),
    })
  }
}

onMounted(() => {
  globalProperties?.logViewEvent("release_home", {
    entity: "home",
  })
  miscConfig().then((res) => {
    if (res.code == 200) {
      const { support_link_platforms } = res.data
      supportPlatforms.value = support_link_platforms
    }
  })
})
</script>

<style lang="scss" scoped>
.release-form-wrapper {
  font-family: HarmonyOS Sans SC;
  width: 100%;
  border-radius: 20px;
  .mobile-nav {
    display: none;
  }
  .group {
    height: 123px;
    padding-left: 27px;
    padding-top: 20px;
    background: (
        url("/src/assets/img/release/upload_bg.png") 95% 0% / contain no-repeat
      ),
      linear-gradient(48deg, #e3faff 36%, #f9dcff 80%),
      linear-gradient(101deg, #4fdeff 0%, #e675ff 99%);
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;

    .title {
      font-family: HarmonyOS Sans SC;
      font-size: 24px;
      font-weight: bold;
      line-height: 28px;
      img {
        width: 16px;
        height: 16px;
        margin-left: 12px;
        cursor: pointer;
      }
    }
    .desc {
      width: calc(100% - 27px);
      font-size: 13px;
      font-weight: normal;
      line-height: 15px;
      color: rgba(0, 0, 0, 0.8);
      margin-top: 8px;
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;
      .desc-text {
        max-width: 340px;
      }
      .desc-more {
        font-size: 12px;
        font-weight: normal;
        line-height: 28px;
        color: #000000;
        opacity: 0.4;
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .close-icon {
      position: absolute;
      right: 16px;
      top: 16px;
      cursor: pointer;
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
  .form {
    .scrollable-content {
      height: 70vh;
      overflow-y: auto;
    }
    margin-top: -20px;
    padding: 28px 40px;
    border-radius: 20px;
    border: 1px solid #fff;
    background: #000000;
    color: #fff;
    .form-title {
      font-size: 22px;
      font-weight: normal;
      line-height: 22px;
    }
    .form-desc {
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
      margin-top: 8px;
      color: rgba(255, 255, 255, 0.5);
    }
    .release-status {
      display: flex;
      justify-content: center;
      .bubble {
        margin-top: 28px;
        padding: 7px 44px;
        border-radius: 24px;
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.3);
        display: flex;
        align-items: center;
        img {
          width: 20px;
          height: 20px;
          margin-right: 10px;
        }
        span {
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
        }
      }
    }
    .release-ruleForm {
      margin-top: 28px;
      :deep(.el-textarea) {
        --el-disabled-bg-color: rgba(255, 255, 255, 0.1);
        --el-disabled-border-color: rgba(255, 255, 255, 0.1);
        --el-input-border-radius: 12px;
      }
      :deep(.el-input) {
        --el-input-height: 40px;
        --el-input-border-radius: 12px;
        --el-input-bg-color: rgba(255, 255, 255, 0.1);
        --el-disabled-bg-color: rgba(255, 255, 255, 0.1);
        --el-input-border-color: rgba(255, 255, 255, 0.1);
        --el-disabled-border-color: rgba(255, 255, 255, 0.1);
        --el-text-color-regular: #fff;
        .el-input__wrapper {
          padding: 13px 20px;
          font-size: 16px;
          font-weight: normal;
          line-height: 22px;

          .el-input__inner {
            --el-input-inner-height: 22px;
            --el-text-color-placeholder: #fff;
            --el-input-placeholder-color: #fff;
            &::placeholder {
              color: #ffffff80 !important;
            }
          }
        }
      }
      :deep(.el-textarea) {
        --el-input-bg-color: rgba(255, 255, 255, 0.1);
        --el-input-border-color: rgba(255, 255, 255, 0.1);
        --el-text-color-regular: #fff;
        .el-textarea__inner {
          height: 142px !important;
          padding: 12px 20px;
        }
      }
      .form-item-label {
        font-size: 16px;
        font-weight: normal;
        line-height: 24px;
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        white-space: nowrap;
        img {
          width: 16px;
          height: 16px;
          margin-left: 12px;
          cursor: pointer;
          vertical-align: text-top;
        }
      }

      .form-item-wrapper {
        .is-error {
          .customer-textarea {
            box-shadow: 0 0 0 1px #f56c6c inset;
            &:focus-within {
              border: none;
              box-shadow: 0 0 0 1px #f56c6c inset;
            }
            &:hover {
              box-shadow: 0 0 0 1px #f56c6c inset;
            }
          }
        }
      }

      .customer-textarea {
        width: 480px;
        height: 142px;
        border-radius: 12px;
        background: rgba(255, 255, 255, 0.1);
        box-shadow: rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;
        padding: 12px 20px;
        .desc-textarea {
          height: 80px;
          background: transparent;
          width: 100%;
          border: none;
          color: #ffffff;
          resize: none;
        }
        &:focus-within {
          border: 1px solid #409eff;
          box-shadow: none;
        }
        &:hover {
          box-shadow: 0 0 0 1px #c0c4cc inset;
        }
        &:focus-within:hover {
          box-shadow: none; /* 重置 hover 样式 */
        }

        &.disabled {
          &:hover {
            // box-shadow: none;
            box-shadow: rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;
          }
          .desc-textarea {
            color: #a8abb2;
            cursor: not-allowed;
          }
          cursor: not-allowed;
        }
      }

      .upload-card {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 20px 0;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 12px;
      }

      .avatar-uploader {
        height: 146px;
        position: relative;
        .avatar {
          width: 146px;
          height: 146px;
          border-radius: 12px;
          display: block;
        }
        .avatar-close {
          position: absolute;
          top: 8px;
          left: 114px;
          width: 24px;
          height: 24px;
          cursor: pointer;
        }
      }

      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 146px;
        height: 146px;
        background: url(/src/assets/img/img-empty.png) 0% 0% / cover;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 36px;
          height: 36px;
        }
      }
      .link-line {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        margin-bottom: 12px;
        :deep(.el-input__validateIcon) {
          display: none;
        }
      }

      .desc-size {
        position: absolute;
        font-size: 12px;
        font-weight: normal;
        line-height: 22px;
        bottom: 12px;
        right: 20px;
        color: rgba(255, 255, 255, 0.5);
      }

      :deep(.el-input-group__prepend) {
        --el-fill-color-light: rgba(255, 255, 255, 0.1);
        --el-border-color: rgba(255, 255, 255, 0.1);
        --el-text-color-placeholder: rgba(255, 255, 255, 0.3);
        box-shadow: none;
        .el-select {
          width: 172px !important;
        }
        .el-select__wrapper {
          box-shadow: none;
          &::after {
            content: "";
            position: absolute;
            height: 20px;
            border-right: 1px solid rgba(255, 255, 255, 0.3);
            right: 0;
          }
        }
      }
      :deep(.el-input-group--prepend) {
        box-shadow: 0 0 0 1px
          var(--el-input-border-color, var(--el-border-color)) inset;
        border-radius: var(
          --el-input-border-radius,
          var(--el-border-radius-base)
        );
        .el-input__wrapper {
          box-shadow: none;
        }
      }
      .add-link {
        cursor: pointer;
      }
    }

    // border-image: linear-gradient(6deg, #e3faff -12%, #f9dcff 116%) 1;
  }
}

@media screen and (max-width: 768px) {
  .release-form-wrapper {
    height: 100vh;
    min-height: 100vh;
    overflow-y: scroll;
    overflow-x: hidden;
    border-radius: 0;
    .mobile-nav {
      position: absolute;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      left: 0;
      top: 20px;
      padding: 0 16px;
      .back {
        width: 40px;
        height: 40px;
      }
      .question {
        width: 24px;
        height: 24px;
      }
      .desc-more {
        font-size: 12px;
        font-weight: normal;
        line-height: 28px;
        color: #000000;
        opacity: 0.4;
        text-decoration: underline;
        cursor: pointer;
      }
      &.fixed {
        height: 60px;
        position: fixed;
        background: #000;
        z-index: 1000;
        top: 0;
        .left {
          display: flex;
          align-items: center;
          .sub-title {
            font-size: 24px;
            font-weight: bold;
            line-height: 24px;
            color: #ffffff;
            margin-left: 16px;
          }
        }
      }
    }
    .group {
      position: relative;
      z-index: -1;
      padding: 72px 16px 16px 16px;
      border-radius: 0;
      height: 188px;
      background: (
          url("/src/assets/img/release/upload_bg_mobile.png") 95% 0% / contain
            no-repeat
        ),
        linear-gradient(48deg, #e3faff 36%, #f9dcff 80%),
        linear-gradient(101deg, #4fdeff 0%, #e675ff 99%);

      .title,
      .desc {
        text-align: center;
        width: auto;
        .desc-more {
          display: none;
        }
      }
      .title {
        img {
          display: none;
        }
      }
      .close-icon {
        display: none;
      }
    }
    .form {
      padding: 28px 16px 64px 16px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      padding-bottom: calc(env(safe-area-inset-bottom) + 78px);
      :deep(.custom-button) {
        width: calc((100vw - 48px) / 2);
      }
      .scrollable-content {
        height: 100%;
        overflow: initial;
      }
    }
  }
}
</style>
<style>
.vip-release-dialog > .dialog-box {
  padding: 0;
}
@media screen and (max-width: 768px) {
  .vip-release-dialog > .dialog-box {
    top: 0;
    padding: 0;
    max-height: 100%;
  }
}
</style>
